(($) => {
  $(document).ready(() => {
    const sideButtons = $('.region-side-buttons .block');
    const region = $('.region-side-buttons');

    $(document).on('click', (evt) => {
      const target = $(evt.target);
      if (!target.closest('.region-side-buttons').length) {
        sideButtons.removeClass('active');
        region.removeClass('active');
      }
    });

    sideButtons.on('click', '.block-icon',  (evt) => {
      const target = $(evt.delegateTarget);
      sideButtons.not(target).removeClass('active');
      target.toggleClass('active');
      if (target.hasClass('active')) {
        region.addClass('active');
      } else {
        region.removeClass('active');
      }
    });
  });
})(jQuery);
